import { assign } from 'lodash';

import DispatchConstants from '../constants/DispatchConstants';
import ZillowSubscriptionConstants from '../constants/ZillowSubscriptionConstants';

const initState = () => ({
    statusesByType: {},
});

const zillowSubscription = (state = initState(), action = {}) => {
    const { type, payload } = action;
    const subscriptionTypePersistentString = ZillowSubscriptionConstants[payload?.subscriptionType]
        ?.persistentString;
    switch (type) {
        case DispatchConstants.ZILLOW_SUBSCRIPTION_GET_SUCCESS:
            return assign({}, state, payload);
        case DispatchConstants.ZILLOW_SUBSCRIPTION_UPDATE_SUCCESS:
            return {
                ...state,
                statusesByType: {
                    ...state.statusesByType,
                    [subscriptionTypePersistentString]: {
                        ...state.statusesByType[subscriptionTypePersistentString],
                        isEmailable: payload.isEmailable,
                    },
                },
            };
        default:
            return state;
    }
};

export default zillowSubscription;
